import router from "../router";
import axios from "axios";
import * as auth from "@/services/auth";

function simpleDelete(url, data, options) {
    createHttpRequest().then(
        http => {
            http
                .delete(url, { data: data })
                .then(function (response) {
                    if (options.success) {
                        options.success(response);
                    }

                    if (options.finally) {
                        options.finally();
                    }
                })
                .catch(function (error) {
                    if (options.error) {
                        options.error(error);
                    }

                    if (options.finally) {
                        options.finally();
                    }
                })
        },
        rejected => {
            if (options.error) {
                options.error(rejected);
            }

            if (options.finally) {
                options.finally();
            }
        }
    );
}

function simplePost(url, data, options) {
    createHttpRequest().then(
        http => {
            http
                .post(url, data)
                .then(function (response) {
                    if (options.success) {
                        options.success(response);
                    }

                    if (options.finally) {
                        options.finally();
                    }
                })
                .catch(function (error) {
                    if (options.error) {
                        options.error(error);
                    }

                    if (options.finally) {
                        options.finally();
                    }
                })
        },
        rejected => {
            if (options.error) {
                options.error(rejected);
            }

            if (options.finally) {
                options.finally();
            }
        }
    );
}

function simpleGet(url, options) {
    createHttpRequest().then(
        http => {
            http
                .get(url, {
                    params: options.params
                })
                .then(function (response) {
                    if (options.success) {
                        options.success(response);
                    }

                    if (options.finally) {
                        options.finally();
                    }
                })
                .catch(function (error) {
                    if (options.error) {
                        options.error(error);
                    }

                    if (options.finally) {
                        options.finally();
                    }
                })
        },
        rejected => {
            if (options.error) {
                options.error(rejected);
            }

            if (options.finally) {
                options.finally();
            }
        }
    );
}

/**
 * Function to create an axios request with an authenticated token
 *
 */
async function createHttpRequest() {
    let tokenResponse = await auth.acquireTokenSilent();

    return axios.create({
        baseURL: process.env.VUE_APP_API_URI,
        headers: {
            Authorization: tokenResponse.accessToken
        },
        responseType: "text"
    });
}

// https://github.com/axios/axios#handling-errors
function parseHttpRequestError(error) {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // eslint-disable-next-line no-console
        console.log(error.response.data);
        // eslint-disable-next-line no-console
        console.log(error.response.status);
        // eslint-disable-next-line no-console
        console.log(error.response.headers);

        return error.response.status + " error: " + error.message + " - " + JSON.stringify(error.response.data);
    }
    else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        return "A request was made but no response was received from the server";
    }
    else {
        // Something happened in setting up the request that triggered an Error
        return error.message;
    }
}

/**
 * Async function which returns a promise for getting data as opposed to callbacks
 * @param {*} url 
 * @param {*} options 
 * @param {*} responseType 
 */
async function simpleGetAsync(url, options = { params: null }, responseType = "json") {
    try {
        const http = await createHttpRequest();

        const response = await http
            .get(url, {
                params: options.params
            });

        return response;
    } catch (err) {
        throw new Error(parseHttpRequestError(err));
    }
}

/**
 * Async function which returns a promise for posting data as opposed to callbacks
 * @param {*} url
 * @param {*} options
 * @param {*} responseType
 */
async function simplePostAsync(url, data) {
    try {
        const http = await createHttpRequest();

        const result = await http.post(url, data);

        return result;
    } catch (err) {
        throw new Error(parseHttpRequestError(err));
    }
}

/**
 * Async function which returns a promise for deleting data as opposed to callbacks
 * @param {*} url
 * @param {*} options
 * @param {*} responseType
 */
async function simpleDeleteAsync(url, data) {
    try {
        const http = await createHttpRequest();

        const result = await http.delete(url, { data: data });

        return result;
    } catch (err) {
        throw new Error(parseHttpRequestError(err));
    }
}

export default {
    simpleDelete,
    simpleGet,
    simplePost,
    parseHttpRequestError,

    simpleGetAsync,
    simplePostAsync,
    simpleDeleteAsync
}